import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaInfoCircle, FaPhone, FaWhatsapp } from "react-icons/fa";
import "./Footer.css";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <h5>Eren Oto Yedek Parça</h5>
            <p>
              Volkswagen, Audi, Seat, Skoda, Porsche, BMW, Mercedes orijinal parçalar. Binek ve Ticari Araçlar
              için Kaporta Aksamları ve Yedek Parça Çözümleri.
            </p>
          </div>

          <div className="footer-links">
            <h6>Hızlı Linkler</h6>
            <ul>
              <li>
                <Link to="/">
                  <FaHome style={{ marginRight: "6px" }} />
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda">
                  <FaInfoCircle style={{ marginRight: "6px" }} />
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim">
                  <FaPhone style={{ marginRight: "6px" }} />
                  İletişim
                </Link>
              </li>
              <li>
                <a
                  href="https://wa.me/905337308779"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp style={{ marginRight: "6px" }} />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h6>İletişim</h6>
            <p>📍 Adres: Maltepe Mah. Yedikule Çırpıcı Yol Sk. Akınsal San. Sit. C Blok No:13 Topkapı - Zeytinburnu / İST.</p>
            <p>
              📞 Telefon: <a href="tel:+905337308779">0533 730 87 79</a>
            </p>
            <p>
              📧 Email: <a href="mailto:erenotoyedekparca@gmail.com">erenotoyedekparca@gmail.com</a>
            </p>
            <p>
              🗺️{" "}
              <a
                href="https://www.google.com/maps/dir//Maltepe,+Ak%C4%B1nsal+Sanayi+Sitesi+No:13+C+Blok,+34025+Zeytinburnu%2F%C4%B0stanbul/@41.0180093,28.8255252,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x14cabb629a1460e7:0xd00d0103520978e!2m2!1d28.907926!2d41.0180386?hl=tr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Haritada Göster
              </a>
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Eren Oto. Tüm hakları saklıdır.</p>
          <p className="developer-credit">
            Hayalindeki web sitesini/mobil uygulamanı oluşturmak için&nbsp;
            <a
              href="https://www.instagram.com/kkayaalii?igsh=MWljYXRzaXUzOWN5Yw==&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
            >
              tıkla ve DM gönder
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;